import React, { Component } from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import BoxWrapper from 'components/atoms/BoxWrapper';
import Button from 'components/atoms/Button/Button';
import CustomTypography from 'components/atoms/CustomTypography';
import { types } from '../../../actions/authentication/types';

class StepTwo extends Component {
    constructor(props) {
        super(props);
        this.dispatch = props.dispatch;
        this.nextStep = props.nextStep;
    }

    componentWillUnmount() {
        this.dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_REQUEST, payload: false });
        this.dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_SUCCESS, payload: false });
        this.dispatch({ type: types.IS_USER_EMAIL_OR_PHONE_NUMBER_EXISTS_FAILURE, payload: false });
    }

    render() {
        return (
            <Container>
                <BoxWrapper mt="50">
                    <Grid container justify="center">
                        <Grid item xs={12} md={4}>
                            <BoxWrapper mb="50" justifyContent="flex-start">
                                <CustomTypography align="center" fontSize="2.6">
                                    Help us make sure we're sending you the right kind of Mobilise
                                    Moment by telling us a bit more about you...
                                </CustomTypography>
                            </BoxWrapper>

                            <BoxWrapper>
                                <Button
                                    onClick={() => this.nextStep('stepThree')}
                                    variant="contained"
                                    color="primary"
                                    mt="20"
                                    width="50"
                                    type="submit"
                                >
                                    Continue
                                </Button>
                            </BoxWrapper>
                        </Grid>
                    </Grid>
                </BoxWrapper>
            </Container>
        );
    }
}

export default connect(null, null)(StepTwo);
